module.exports = __webpack_public_path__ + "img/intelligent_info_1.ff505579.png";